import React from "react"
import { Row, Col, Container } from "react-bootstrap"
import Resources1 from "../../images/resources-img-1.png"
import Resources2 from "../../images/resources-img-2.png"
import Arrow from "../../images/long-arrow-right.svg"
import { useMediaQuery } from "react-responsive"

const EducationalResources = () => {
  let isMobile = useMediaQuery({ query: "(max-device-width: 576px)" })
  return (
    <section id="educational-resources">
      <Container>
        <Row className="row">
          <Col md={6}>
            <div className="title-txt">Key Strategy</div>
            <h1>Educational Resources</h1>
            {isMobile ? (
              <></>
            ) : (
              <button className="find-help-btn btn">
                Learn more
                <span className="pl-2">
                  <img src={Arrow} alt="" style={{ margin: "0" }} />
                </span>
              </button>
            )}
          </Col>
          <Col md={6} className=" mt-5">
            <p>
              Are you hoping to learn more about addiction rehabilitation? With
              our large selection of educational resources about rehabilitation,
              you can gain an understanding of what you need on your way to
              transform your life.
            </p>
          </Col>
        </Row>
        {isMobile ? (
          <button className="find-help-btn btn">
            Learn more
            <span className="pl-2">
              <img src={Arrow} alt="" style={{ margin: "0" }} />
            </span>
          </button>
        ) : (
          <></>
        )}
        <div className="row resourse-desc-wrapper">
          {" "}
          <Col md={6} className=" img-wrapper-xs">
            <img src={Resources1} alt="" className="img-one img-fluid" />
            <img src={Resources2} alt="" className="img-two img-fluid" />
          </Col>
        </div>

        <div className="row resourse-desc-wrapper">
          <Col md={6} className=" mt-auto text-wrapper">
            <p>
              Here at Rehab Find, we have created the most helpful,
              comprehensive collection of educational resources about addiction
              and rehabilitation anywhere, online! There are comprehensive
              descriptions, in-depth guides, effective treatment trends,
              cutting-edge research summaries, specialist interviews, firsthand
              accounts, extensive case studies, and so much more! It is vital
              that a person undergoing the rehabilitation journey to be equipped
              with the best information. Learning about addiction rehabilitation
              is made easier with Rehab Find’s free online and offline resources
              that are available anytime, anywhere on the planet.
            </p>
          </Col>
          <Col md={6} className=" img-wrapper-lg text-center">
            <img src={Resources2} alt="" className="img-one img-fluid" />
            <img src={Resources1} alt="" className="img-two img-fluid" />
          </Col>
        </div>
      </Container>
      <hr />
    </section>
  )
}

export default EducationalResources
